<template>
  <div>
    <div class="text-center countdown" v-if="currentTime">
      <p>Next episode unlocks in</p>
      <p><span v-if="days">{{ days }}:</span><span v-if="hours">{{ hours | formatTime }}:</span><span>{{ minutes | formatTime }}:{{ seconds | formatTime }}</span></p>
    </div>
    <p v-if="!settings.saved">
      Choose how long before you can access new episodes of the story below
    </p>
    <div class="text-center" v-if="!currentTime">
    </div>
    <form v-if="!settings.saved" onsubmit="return false">
      <div class="field">
        <label class="radio">
          <input type="radio" name="5min" class="control" :value="5" v-model="episode_interval">
          5 Minutes
        </label>
        <label class="radio">
          <input type="radio" name="1hr" class="control" :value="60" v-model="episode_interval">
          1 Hour
        </label>
        <label class="radio">
          <input type="radio" name="1day" class="control" :value="1440" v-model="episode_interval">
          1 Day
        </label>
      </div>
      <div class="field is-horizontal">
        <div class="field-label">
          <!-- Left empty for spacing -->
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <button @click="save" class="button is-light">
                Save setting
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { updateProgress } from '@/firebaseService.js'
export default {
  props: {
    episodeEnded: {
      type: Number,
      required: true
    },
    speed: {
      type: Number,
      default: 1000
    }
  },
  data () {
    return {
      currentTime: this.deadline - Date.parse(new Date()),
      settings: {
        episode_intervalProxy: null,
        notify: true,
        saved: false
      }
    }
  },
  mounted () {
    this.countdown()
    if (this.currentTime < ((this.episode_interval * 60 * 1000) - (5 * 60 * 1000))) {
      this.settings.saved = true
    }
  },
  watch: {
    deadline (to) {
      this.countdown()
      this.$emit('timerUpdated')
    },
    settings: {
      handler (to) {
        if (this.settings.episode_intervalProxy) {
          var update = { episode_interval: this.settings.episode_intervalProxy }
          updateProgress(update)
        }
      },
      deep: true
    }
  },
  computed: {
    episode_interval: {
      get () {
        return this.$root.progress.episode_interval
      },
      set (val) {
        this.settings.episode_intervalProxy = val
      }
    },
    deadline () {
      if (!this.episodeEnded) {
        return 0
      }
      var newdeadline = this.episodeEnded + parseInt(this.episode_interval) * 60 * 1000
      return newdeadline
    },
    seconds () {
      return Math.floor((this.currentTime / 1000) % 60)
    },
    minutes () {
      return Math.floor((this.currentTime / 1000 / 60) % 60)
    },
    hours () {
      return Math.floor((this.currentTime / (1000 * 60 * 60)) % 24)
    },
    days () {
      return Math.floor(this.currentTime / (1000 * 60 * 60 * 24))
    }
  },
  filters: {
    formatTime (value) {
      if (value < 10) {
        return '0' + value
      }
      return value
    }
  },
  methods: {
    countdown () {
      this.currentTime = this.deadline - Date.parse(new Date())
      if (this.currentTime > 0) {
        if (this.currentTime < ((this.episode_interval * 60 * 1000) - (5 * 60 * 1000))) {
          this.settings.saved = true
        }
        setTimeout(this.countdown, this.speed)
      } else {
        this.$emit('timerComplete')
        this.currentTime = null
      }
    },
    save () {
      this.settings.saved = true
    }
  }
}
</script>

<style lang="css" scoped>
.countdown span {
  font-size: 5rem;
}
</style>
